import clsx from "clsx";
import { Link, useLocation } from "wouter";

import { activeFor, mobileDestinations } from "./navigation";

export function MobileBottomNav({
  onPrefetch,
}: {
  onPrefetch?: (path: string) => void;
}) {
  const [location] = useLocation();
  return (
    <nav aria-label="Mobile navigation" className="v2-mobile-nav">
      <div className="v2-mobile-nav__inner">
        {mobileDestinations.map(({ href, label, icon: Icon }) => {
          const active = activeFor(location, href);
          return (
            <Link
              aria-current={active ? "page" : undefined}
              aria-label={label}
              className={clsx(active && "is-active")}
              href={href}
              key={href}
              onFocus={() => onPrefetch?.(href)}
              onMouseEnter={() => onPrefetch?.(href)}
              onPointerDown={() => onPrefetch?.(href)}
            >
              <Icon aria-hidden />
              <span>{label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
